export default "__VITE_ASSET__Du8oGsQZ__"